import Component from "@glimmer/component";
import { service } from "@ember/service";
import { trustHTML } from "@ember/template";
import { userPath } from "discourse/lib/url";
import DUserAvatarFlair from "discourse/ui-kit/d-user-avatar-flair";
import dConcatClass from "discourse/ui-kit/helpers/d-concat-class";
import { renderAvatar } from "discourse/ui-kit/helpers/d-user-avatar";

export default class ChatUserAvatar extends Component {
  @service chatStateManager;
  @service chat;

  get avatar() {
    return trustHTML(
      renderAvatar(this.args.user, { imageSize: this.avatarSize })
    );
  }

  get interactive() {
    return this.args.interactive ?? true;
  }

  get avatarSize() {
    return this.args.avatarSize || "tiny";
  }

  get showPresence() {
    return this.args.showPresence ?? true;
  }

  get isOnline() {
    const users = (this.args.chat || this.chat).presenceChannel?.users;

    return (
      this.showPresence &&
      !!users?.find(
        ({ id, username }) =>
          this.args.user?.id === id || this.args.user?.username === username
      )
    );
  }

  get userPath() {
    return userPath(this.args.user.username);
  }

  get ariaHidden() {
    return this.args.ariaHidden ?? false;
  }

  get isFullPageActive() {
    return this.chatStateManager.isFullPageActive ? "true" : "false";
  }

  <template>
    <div
      class={{dConcatClass "chat-user-avatar" (if this.isOnline "is-online")}}
      data-username={{@user.username}}
    >
      {{#if this.interactive}}
        <a
          aria-hidden={{if this.ariaHidden "true"}}
          class="chat-user-avatar__container"
          data-user-card={{@user.username}}
          href={{this.userPath}}
          tabindex={{if this.ariaHidden "-1"}}
        >
          {{this.avatar}}
          <DUserAvatarFlair @user={{@user}} />
        </a>
      {{else}}
        <span
          aria-hidden={{if this.ariaHidden "true"}}
          class="chat-user-avatar__container"
        >
          {{this.avatar}}
          <DUserAvatarFlair @user={{@user}} />
        </span>
      {{/if}}
    </div>
  </template>
}
